import { RootState } from "RootReducer";

export const selectSelectedBclOption = (state: RootState) => state.prepCreate.selectedBclOption;
